import type { Square } from '@domain/chess/types';
import type { TacticFilter, TacticKind } from './kinds';

export interface TacticPuzzle {
  kind: TacticKind;
  /** Position before the tactic exists. White to move. */
  fen: string;
  from: Square;
  to: Square;
  san: string;
}

/**
 * Hand-authored one-move tactics.
 * Add an entry here; if its category is new, add that category in kinds.ts first.
 */
export const TACTIC_CATALOG: readonly TacticPuzzle[] = [];

export function tacticsFor(filter: TacticFilter): readonly TacticPuzzle[] {
  if (filter === 'all') return TACTIC_CATALOG;
  return TACTIC_CATALOG.filter((t) => t.kind === filter);
}

export function nextTacticPuzzle(
  filter: TacticFilter,
  opts?: { excludeFen?: string },
): TacticPuzzle | null {
  const pool = tacticsFor(filter);
  if (pool.length === 0) return null;
  const rest = opts?.excludeFen
    ? pool.filter((t) => t.fen !== opts.excludeFen)
    : pool;
  const choices = rest.length > 0 ? rest : pool;
  const i = Math.floor(Math.random() * choices.length);
  return choices[i] ?? null;
}

/** Follow the piece that started on `start` through `moves`. Null if captured. */
export function pieceEndsOn(
  start: Square,
  moves: readonly { from: Square; to: Square }[],
): Square | null {
  let sq: Square | null = start;
  for (const m of moves) {
    if (sq === null) break;
    if (m.from === sq) sq = m.to;
    else if (m.to === sq) sq = null;
  }
  return sq;
}
